module.exports = __webpack_public_path__ + "static/biennale-thin-22184bc2bf2dc4f6b5d9e76c73689c3a.otf";